import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { Panel } from "@poseidon/ui/components/Panel";
import config from "@poseidon/utils/config";
import { useParams } from "react-router-dom";
import Action from "../../Action/Action";
import { FileManagement } from "../../Files";

export default function FileManagementPage({ fileCategory }) {
  const params = useParams();
  const { sailorId, fileGroup } = params;
  const { SaltCollection, fileResolvers } = config;
  const label = fileResolvers[fileGroup].fileGroupLabel;
  const crumb = {
    to: `/sailors/:sailorId/:fileGroup/files`,
    text: label,
  };
  useCrumb(`/sailors/:sailorId/:fileGroup/files`, crumb);

  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <Typography variant="h5">Files &amp; Actions</Typography>
      <Panel title={`${label} File Management`} expandable>
        <FileManagement
          fileCategory={fileCategory}
          resolveMetadata={fileResolvers[fileGroup]}
          sailorId={sailorId}
        />
      </Panel>
      <Panel title={`${label} Action status`}>
        <Action
          entity={SaltCollection.Sailor}
          entityId={sailorId}
          entityKey={fileGroup}
        />
      </Panel>
    </Stack>
  );
}
